import {Injectable} from "@angular/core";
import {AuthApiService} from "../auth/auth-api.service";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";

@Injectable()
export class ConfigService {

    public static readonly DAYS_LIMIT_INITIAL_START_TERM = "days.limit.initial.start.term";

    constructor(private http: HttpClient, private auth: AuthApiService) {
    }

    async getServerConfig(): Promise<any> {
        return firstValueFrom(this.http.get<any>("/fonzie/config", {headers: this.auth.getHttpHeaderOptions()}));
    }
}
